import { OnlineClassImport } from './Import'
const { RoutesMap, ScheduleList, AddSchedule, UpdateSchedule } = OnlineClassImport

const OnlineClassRoute = () => {
    return [
        {
            path: RoutesMap.SCHEDULE_LIST.path,
            element: <ScheduleList />
        },

        {
            path: RoutesMap.ADD_SCHEDULE.path,
            element: <AddSchedule />
        },

        {
            path: RoutesMap.UPDATE_SCHEDULE.path,
            element: <UpdateSchedule />
        },
    ]
}

export default OnlineClassRoute;
